import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../helpers/url_helper";
import { get, post } from "../../helpers/api_helper";

export const getGannWheel = createAsyncThunk(
  "getGannWheel",
  async (payload, Thunk) => {
    try {
      let response = await get(URL.GET_WHEEL_PROPERTIES, payload);
      return response.data;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  }
);

export const updateGannWheel = createAsyncThunk(
  "updateGannWheel",
  async (payload, Thunk) => {
    try {
      let response = await post(URL.POST_WHEEL_PROPERTIES, payload);
      return response;
    } catch (error) {
      console.log(error, "<====error");

      return Thunk.rejectWithValue(error);
    }
  }
);
